import React from 'react';

const role = {
	currentUserRole: null,
	setCurrentUserRole: () => undefined,
};

export const CurrentUserRoleContext = React.createContext(role);
